/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_cloud_logic_custom": [
        {
            "name": "Impressions",
            "endpoint": "https://4eoh1izh32.execute-api.us-east-1.amazonaws.com/beta",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
